module.exports = __webpack_public_path__ + "img/settings.ca56c172.svg";